import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {RiaListResponse, RiaQueryFilter} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useRias = (
  filter: RiaQueryFilter,
  options?: Omit<UseQueryOptions<RiaListResponse, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<RiaListResponse, AxiosError>({
    queryKey: riskSurveyQueryKeys.rias.list(filter),
    queryFn: ({signal}) => riskSurveyQueries.getRias(filter, signal),
    staleTime: 30_000,
    gcTime: 300_000,
    ...options
  })
}
